import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AppLink from '../../../components/AppLink';
import { buttonSubmitStyle } from '../../../components/ButtonSubmit';
import { NAVIGATION } from '../../App/constants';
import {
  cityPropTypes,
  SEARCH_PAGE_TYPE_TO_TRANSPORT_TYPE,
} from '../constants';
import messages from './messages';

const ReturnTrip = ({
  currentPageType,
  destinationCity,
  isMainPage,
  originCity,
}) => {
  const currentPageTransportType =
    SEARCH_PAGE_TYPE_TO_TRANSPORT_TYPE[currentPageType];
  const path = `${NAVIGATION.SEARCH}/${destinationCity.slug}/${
    originCity.slug
  }${isMainPage ? '' : `/${currentPageType}`}`;

  return (
    <AppLink
      content={
        <FormattedMessage
          {...messages[
            currentPageTransportType ? 'returnTripSpecific' : 'returnTrip'
          ]}
          values={{
            transportType: currentPageTransportType,
            origin: originCity.name,
            destination: destinationCity.name,
          }}
        />
      }
      id={path}
      mustReload
      styles={buttonSubmitStyle}
      url={path}
    />
  );
};

ReturnTrip.propTypes = {
  currentPageType: PropTypes.string.isRequired,
  destinationCity: cityPropTypes,
  isMainPage: PropTypes.bool.isRequired,
  originCity: cityPropTypes,
};

export { ReturnTrip };
